import React, { useState } from 'react';
import styles from '../css/LoginForm.module.css'; 
import { Link, Navigate } from 'react-router-dom'; 
import { loginUser } from '../service/apiService';
import { toast, ToastContainer } from 'react-toastify';  
import 'react-toastify/dist/ReactToastify.css';  

const LoginForm = () => {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [isLogInSuccessful, setIsLogInSuccessful] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const token = localStorage.getItem('token')
 
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const response = await loginUser(formData); 
      if (response.token) {
        localStorage.setItem('token', response.token);
        toast.success('Log In success!', {
          autoClose: 3000,
        });
        setIsLogInSuccessful(true);
      }
    } catch (error) {
      toast.error('Failed to Log In. Please try again.', {
        autoClose: 3000,
      });
    } finally {
      setIsLoading(false);
    }
  };

  if (isLogInSuccessful) {
    return <Navigate to="/upload" />;
  }
  if(token){
    return <Navigate to="/upload" />;
  }

  return (
    <div className={styles.loginContainer}>
      <form className={styles.loginForm} onSubmit={handleSubmit}>
        <h2>Login</h2>
        <input
          type="email"
          name="email"
          placeholder="Email Address"
          value={formData.email}
          onChange={handleChange}
          required
        />
        <input
          type="password"
          name="password"
          placeholder="Password"
          value={formData.password}
          onChange={handleChange}
          required
        />
        <button type="submit" disabled={isLoading}>Log In</button>
        <p>Don't have an account? <Link to="/signup">Sign up</Link></p>
      </form>
      <ToastContainer />
    </div>
  );
};

export default LoginForm;
